import { z } from 'zod';
/**
 * Delete Partner Material Response
 * DELETE /api/v2/admin/partner-materials/:id
 */ export const DeletePartnerMaterialResponseSchema = z.object({
    success: z.literal(true)
});

//# sourceMappingURL=delete-partner-material.schema.js.map